import { Location, History } from "history";
import { getStartOfWeek, parseDayMonthYearToDate } from "./schedulingDateUtils";
import { Period } from "../SchedulingTypes";

// Get the current display date and period
export function getCurrentDisplayDateAndPeriod(
    urlParams: { date?: string; period?: string },
    fallbackPeriod?: string | null
): {
    displayDate: Date;
    period: Period | undefined
} {
    // Get the current date and period from the url params state
    const rawPeriod = urlParams.period;
    const period: Period | undefined = rawPeriod === 'day' ? 'day' : rawPeriod === 'week' ? 'week' : undefined;
    const rawDate = urlParams.date;

    // Resolve the period for the date calculation, the url wins over the fallback
    const resolvedPeriod: Period = period ?? (fallbackPeriod === 'day' ? 'day' : 'week');

    // Parse the date into YYYY-MM-DD
    let parsedDate = rawDate ? parseDayMonthYearToDate(rawDate) : null;

    // When the date is null, set the date to today
    if (!parsedDate) parsedDate = new Date();

    // For week periods, move the date to the start of the week
    const displayDate = resolvedPeriod === "week" ? getStartOfWeek(parsedDate) : parsedDate;

    return { displayDate, period };
}

// Get the date and period from the url
export function getDatePeriodFromUrl(location: Location) {
    // Get the current search params
    const search = new URLSearchParams(location.search);

    // Return the period and date params
    return {
        period: search.get("period") ?? undefined,
        date: search.get("date") ?? undefined,
    };
};

// Set the scheduling url
export function setSchedulingUrl(
    params: Record<string, string | undefined>,
    history: History,
    location: Location
) {
    // Generate a new search params object
    const search = new URLSearchParams();

    // Loop through the params to create the new search params
    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            search.set(key, value);
        }
    });

    // Apply the new url
    history.push({
        pathname: location.pathname,
        search: search.toString(),
    });
};